import { connect } from 'react-redux';
import queryString from 'query-string';
import { updateUrlQuery } from '../../store/app/app.actions';
import { TransactionsTablesTabs } from './transactionsTablesTabs';

const mapStateToProps = (state) => {
	return {
		query: queryString.parse(state.router.location.search),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateQuery: (data) => dispatch(updateUrlQuery(data)),
	};
};

const TransactionsTablesTabsContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)(TransactionsTablesTabs);

export { TransactionsTablesTabsContainer };
